import React from 'react'
import { teamIds } from 'src/constants/personalizationIds'
import CollegeFootball from 'src/components/page/college-football'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Alabama Crimson Tide"
    teamId={teamIds['Alabama Crimson Tide']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Alabama.png"
  />
)
